import { useAuthStore } from "./auth";
import { isDevReadOnly } from "../utils/devStoreOverride";

/*
    ตัวกันข้อมูลหายเงียบ ๆ ตอนเขียน jobchain ไม่ได้

    ทำไมต้องมี : firebase RTDB เขียนแบบ optimistic — set() จะอัปเดต cache ในเครื่อง
    และยิง event ให้ UI ทันทีก่อนที่ server จะตอบ ถ้า server ปฏิเสธ (permission_denied)
    มันจะ rollback เงียบ ๆ แคชเชียร์จึงเห็นออเดอร์ขึ้นปกติ ขายต่อไปได้ทั้งวัน
    แล้วข้อมูลหายตอน reload — อันตรายกว่าระบบล่มตรง ๆ เพราะไม่มีใครรู้ตัว

    เดิม jobs.cloud.plugin.ts เขียน set(...).then() โดยไม่มี .catch() เลย
    error เลยหายไปเงียบ ๆ ซึ่งเป็นบั๊กที่มีอยู่ก่อนเรื่อง custom claim ด้วยซ้ำ

    flow เมื่อเจอ permission_denied ที่ jobchain :
      alert เตือนให้แคชเชียร์รู้ตัว แล้ว logout ไป login ใหม่

    การ logout คือตัวห้ามขายต่อในตัวเอง เพราะเด้งไปหน้า /login แล้วทำอะไรไม่ได้
    ถ้า login ใหม่แล้วยังพังอีกก็จะโดนเด้งอีก ซึ่งยอมรับได้ เพราะ backfill ควรทำให้
    ทุกร้านมี claim ครบแล้ว ร้านที่ยังไม่มีถือว่าผิดปกติจริง ๆ และควรหลุดออกทันที
    ให้รู้ตัว ดีกว่าขายต่อแล้วข้อมูลหาย

    error ที่ไม่ใช่เรื่องสิทธิ์ (เน็ตหลุด) ไม่ยุ่ง firebase queue + retry ให้เอง
*/

// error จาก firebase ที่แปลว่า "rules ไม่ให้เขียน" ไม่ใช่เน็ตหลุด
// (เน็ตหลุด firebase จะ queue ไว้เฉย ๆ ไม่ reject)
function isPermissionDenied(error: any) {
    if (!error) return false;

    const code = String(error.code || "").toLowerCase();
    const message = String(error.message || error).toLowerCase();

    return code.includes("permission") || message.includes("permission_denied") || message.includes("permission denied");
}

export const useRtdbGuardStore = defineStore("rtdbGuard", {
    state: () => {
        return {
            // กันไม่ให้ alert ซ้อนกันหลายรอบตอน job หลายตัวพังพร้อมกัน
            handling: false,
        };
    },

    actions: {
        /**
         * เรียกเมื่อ อ่าน/เขียน jobchain ไม่สำเร็จ
         *
         * @param source จุดที่พัง เอาไว้ดูว่าพังตรงไหน
         * @param error  error object จาก firebase
         */
        reportJobchainFailure(source: string, error?: any) {
            if (this.handling) return;

            // dev สวมร้านอื่น: claim ไม่ตรงโดยตั้งใจ เขียนไม่ได้คือถูกแล้ว ห้ามเด้งออก
            if (isDevReadOnly()) {
                console.warn(`[rtdbGuard] dev read-only ข้าม ${source}`, error);
                return;
            }

            // error ที่ไม่ใช่เรื่องสิทธิ์ (เช่นเน็ตมีปัญหา) ไม่ต้องทำอะไร
            // firebase จะ retry ให้เองอยู่แล้ว
            if (error && !isPermissionDenied(error)) {
                console.error(`[rtdbGuard] ${source} พังแต่ไม่ใช่เรื่องสิทธิ์`, error);
                return;
            }

            console.error(`[rtdbGuard] เขียน/อ่าน jobchain ไม่ได้ที่ ${source}`, error);
            this.handling = true;

            // เตือนให้แคชเชียร์รู้ตัวก่อน แล้วเด้งไป login ใหม่
            // ใช้ alert เพราะมันหยุด thread บังคับให้กดรับทราบก่อน ไม่ให้พลาด
            alert(
                "บันทึกข้อมูลลงระบบไม่ได้\n\n" +
                "ระบบจะออกจากระบบและให้เข้าใหม่\n" +
                "กรุณาอย่าขายต่อจนกว่าจะเข้าระบบได้ตามปกติ"
            );

            useAuthStore().logout();
        },
    },
});
